import PropTypes from 'prop-types';
import { useFragment, graphql } from 'react-relay';
import { getCheckoutChargesCurrencyDisclaimer } from '../helpers/getCheckoutChargesCurrencyDisclaimer';

import styles from './styles/CheckoutSidebarChargesDisclaimer.scss';

const CheckoutSidebarChargesDisclaimer = props => {
    const { transaction: transactionRef, viewer: viewerRef } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutSidebarChargesDisclaimer_viewer on Viewer {
                ...getCheckoutChargesCurrencyDisclaimer_viewer
            }
        `,
        viewerRef
    );

    const transaction = useFragment(
        graphql`
            fragment CheckoutSidebarChargesDisclaimer_transaction on Transaction {
                ...getCheckoutChargesCurrencyDisclaimer_transaction
                isPrivateOffer
                isShippingKnownAtCheckout
                mostRecentOffer {
                    quantity
                }
            }
        `,
        transactionRef
    );

    const { isPrivateOffer, isShippingKnownAtCheckout } = transaction;
    const quantity = transaction?.mostRecentOffer?.quantity;
    const currencyDisclaimer = getCheckoutChargesCurrencyDisclaimer(viewer, transaction);

    const showChargeDisclaimer = !!quantity && !(isPrivateOffer && isShippingKnownAtCheckout);

    if (!showChargeDisclaimer || !currencyDisclaimer) {
        return null;
    }

    return (
        <div className={styles.wrapper} data-tn="checkout-review-charges-disclaimer">
            {showChargeDisclaimer && !!currencyDisclaimer && <div>{currencyDisclaimer}</div>}
        </div>
    );
};

CheckoutSidebarChargesDisclaimer.propTypes = {
    viewer: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
};

export default CheckoutSidebarChargesDisclaimer;
